import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';

export const Header = styled.div`
  border-bottom: 1px solid ${styles.colors.GRAY_LIGHT_2};
  ${mixins.flexPosition({ justify: 'space-between' })}
  margin: 0 20px;
  padding: 20px 0 10px;

  ${({ headerStyles }) => headerStyles}
`;

export const Title = styled.div`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_5, styles.fontWeights.NORMAL)}
  line-height: 22px;
`;

export const Content = styled.div`
  padding: 20px;

  ${({ contentStyles }) => contentStyles}
`;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/Box/style.js